// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"18357": "70fb16f8c80d","1858": "93ca3742e0c8","53911": "3cd5c82348a5","61788": "5e176218aec9","66863": "c939bdd77392","78990": "aa917893b43d",}[chunkId] + ".css"
}